export const APP_LOADED = "APP_LOADED";
export const USER_SIGNED_IN = "USER_SIGNED_IN";
export const USER_SIGNED_OUT = "USER_SIGNED_OUT";
export const UPDATE_USER_INFO = "UPDATE_USER_INFO";

export const FETCH_TASKLISTS = "FETCH_TASKLISTS";
export const FETCH_TASKLIST = "FETCH_TASKLIST";
export const CREATE_TASKLIST = "CREATE_TASKLIST";
export const UPDATE_TASKLIST = "UPDATE_TASKLIST";
export const DELETE_TASKLIST = "DELETE_TASKLIST";
export const SELECT_TASKLIST = "SELECT_TASKLIST";

export const FETCH_ALL_TASKS = "FETCH_ALL_TASKS";
export const FETCH_TASKS = "FETCH_TASKS";
export const FETCH_COMPLETED_TASKS = "FETCH_COMPLETED_TASKS";
export const FETCH_CHILDREN = "FETCH_CHILDREN";
export const FETCH_TASK = "FETCH_TASK";
export const CREATE_TASK = "CREATE_TASK";
export const ADD_TASK = "ADD_TASK";
export const CREATE_SUB_TASK = "CREATE_SUB_TASK";
export const ADD_SUB_TASK = "ADD_SUB_TASK";
export const UPDATE_TASK = "UPDATE_TASK";
export const DELETE_TASK = "DELETE_TASK";
export const LOADING_TASKS = "LOADING_TASKS";
export const SELECT_TASK = "SELECT_TASK";

export const SWITCH_COLOR_MODE = "SWITCH_COLOR_MODE";
